<div class="wrapper">
	<div class="header">
		<ion-icon (click)="dismiss()" src="../../../../assets/icon/cross_white.svg"></ion-icon>
	</div>
	<div [formGroup]="form">
		<ion-item class="ion-invalid">
			<ion-input formControlName="value" name="value" [placeholder]="'country_selection.placeholder' | translate"></ion-input>
		</ion-item>
	</div>
	<div class="country-list">
		@for (country of countriesArray; track country) {
			@if (country) {
				<div (click)="dismissWithValue(country)" class="country">
					<ion-icon [src]="'../../../../assets/flag/flags-country/' + country?.flagClass + '.svg'"></ion-icon>
					<h3>
						{{ country?.name }}
					</h3>
					<div class="selected-circle">
						<div [class.show]="compareCode(country?.dialCode)" class="inner-circle"></div>
					</div>
				</div>
			}
		}
	</div>
</div>
